import { useEffect, useRef, useState } from 'react';

import { useQuery } from '@hooks/reactQuery';

import { auth, map } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getStartupPolygon } from '@api/map';

import { TMarker } from '@interfaces/map/map';

import { EDataType } from '@enums/map';

import { refetchOptions } from '@constants/common';
import { STARTUP_POLYGON } from '@constants/queryKeys';

export const useQueryStartupPolygon = () => {
	const {
		activeOrganisation: organizationId,
		accessPermission: {
			assetOwnerOrganizationAdministrator,
			assetOwnerAttributeUpdater,
			assetOwnerContact,
			assetOwnerDefaultContact,
			assetOwnerSignatory,
			assetOwnerViewer,
			assetOwnerApprovalUnit,
			assetOwnerManageRequests,
			networkOperatorAssetEnquirer,
			networkOperatorAssetViewer,
			assetConsumerAssetEnquirer,
			assetConsumerAssetViewer,
		},
	} = useAppSelector(auth);

	const { markerType } = useAppSelector(map);

	const defaultMarkerTypeRef = useRef<TMarker>(markerType);

	const [defaultMarkerType, setDefaultMarkerType] = useState<TMarker | null>(null);

	useEffect(() => {
		if (!defaultMarkerTypeRef.current) {
			(defaultMarkerTypeRef as any).current = markerType;
		}
	}, [markerType]);

	useEffect(() => {
		if (defaultMarkerTypeRef.current) {
			setDefaultMarkerType(defaultMarkerTypeRef.current);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [defaultMarkerTypeRef.current]);

	const isAssetOwnerRole = (
		assetOwnerContact ||
		assetOwnerSignatory ||
		assetOwnerDefaultContact ||
		assetOwnerViewer ||
		assetOwnerAttributeUpdater ||
		assetOwnerViewer ||
		assetOwnerOrganizationAdministrator ||
		assetOwnerApprovalUnit ||
		assetOwnerManageRequests ||
		networkOperatorAssetEnquirer ||
		networkOperatorAssetViewer ||
		assetConsumerAssetEnquirer ||
		assetConsumerAssetViewer
	);

	const { isLoading: isLoadingStartupPolygon, data: startupPolygon } = useQuery({
		queryKey: [STARTUP_POLYGON, isAssetOwnerRole, defaultMarkerType],
		queryFn: () => {
			if (((isAssetOwnerRole || defaultMarkerType === EDataType.sites) && markerType && organizationId)) {
				return getStartupPolygon();
			}

			return Promise.resolve(null);
		},
		enabled: [isAssetOwnerRole || defaultMarkerType === EDataType.sites, !!markerType],
		...refetchOptions,
	});

	return {
		isLoadingStartupPolygon,
		startupPolygon: startupPolygon || null,
	};
};
